var map = {
	"./death.webp": "bc6f",
	"./judgement.webp": "d82e",
	"./justice.webp": "a612",
	"./strength.webp": "bfc0",
	"./temperance.webp": "8611",
	"./the-chariot.webp": "8b3f",
	"./the-devil.webp": "1b5f",
	"./the-emperor.webp": "3284",
	"./the-empress.webp": "a5bb",
	"./the-fool.webp": "8c9b",
	"./the-hanged-man.webp": "fc3b",
	"./the-hermit.webp": "167c",
	"./the-juggler.webp": "ce79",
	"./the-lovers.webp": "7c6a",
	"./the-moon.webp": "9819",
	"./the-pope.webp": "0833",
	"./the-popess.webp": "00d7",
	"./the-star.webp": "0dc6",
	"./the-sun.webp": "2ea2",
	"./the-tower.webp": "5a34",
	"./the-world.webp": "a081",
	"./wheel-of-fortune.webp": "6747"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c640";